<section class="mediatype-stat-cards">
  <ul>
    @if (
      { profitableChannels: profitableChannelsListener?.data$ | async };
      as STATE
    ) {
      @if (!STATE.profitableChannels) {
        <div class="loader-container">
          <p>Chargement...</p>
          <div class="spinner"></div>
        </div>
      } @else {
        @for (mediaType of mediaTypesKeys; track mediaType) {
          @if (STATE.profitableChannels[mediaType]?.length) {
            @for (
              profitableChannel of STATE.profitableChannels[mediaType];
              track profitableChannel
            ) {
              <li>
                <p>{{ mediaTypes[mediaType] }}</p>
                <div>
                  <p>Dépense totale</p>
                  <p>
                    {{
                      profitableChannel.totalCost
                        | currency: 'XOF' : 'FCFA' : '1.0-0'
                    }}
                  </p>
                </div>
                <div>
                  <p>Support rentable</p>
                  <p>{{ profitableChannel.channelName }}</p>
                </div>
              </li>
            }
          }
        }
      }
    }
  </ul>
</section>
